import { useState, useEffect } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Lock } from "lucide-react";

export default function AdminLogin() {
  const { user, login, loading } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => { if (user && user.role === "admin") nav("/admin"); }, [user, nav]);

  if (loading) return null;
  if (user && user.role === "admin") return <Navigate to="/admin" replace/>;

  const submit = async (e) => {
    e.preventDefault(); setErr(""); setBusy(true);
    const r = await login(email, password); setBusy(false);
    if (r.ok) nav("/admin"); else setErr(r.error);
  };

  return (
    <div className="max-w-md mx-auto px-4 py-16" data-testid="admin-login-page">
      <div className="bg-white border border-slate-200 rounded-xl p-8">
        <div className="w-12 h-12 rounded-md bg-slate-900 grid place-items-center mb-4"><Lock className="w-5 h-5 text-orange-500"/></div>
        <h1 className="text-2xl font-extrabold" style={{fontFamily:"'Cabinet Grotesk',sans-serif"}}>Admin Login</h1>
        <p className="text-sm text-slate-500 mt-1">Sign in to manage hireds.in content.</p>
        <form onSubmit={submit} className="mt-6 space-y-4">
          <div>
            <label className="text-xs font-bold uppercase tracking-wider text-slate-700">Email</label>
            <Input data-testid="admin-email" required type="email" value={email} onChange={(e)=>setEmail(e.target.value)} className="mt-1"/>
          </div>
          <div>
            <label className="text-xs font-bold uppercase tracking-wider text-slate-700">Password</label>
            <Input data-testid="admin-password" required type="password" value={password} onChange={(e)=>setPassword(e.target.value)} className="mt-1"/>
          </div>
          {err && <div data-testid="login-error" className="text-sm text-red-600 bg-red-50 border border-red-200 p-2 rounded">{err}</div>}
          <Button data-testid="admin-login-submit" type="submit" disabled={busy} className="w-full h-11 bg-orange-600 hover:bg-orange-700 text-white">{busy?"Signing in…":"Sign In"}</Button>
        </form>
      </div>
    </div>
  );
}
